import { render, staticRenderFns } from "./regionTreeSelect.vue?vue&type=template&id=b40ebf82&scoped=true"
import script from "./regionTreeSelect.vue?vue&type=script&lang=js"
export * from "./regionTreeSelect.vue?vue&type=script&lang=js"
import style0 from "./regionTreeSelect.vue?vue&type=style&index=0&id=b40ebf82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40ebf82",
  null
  
)

export default component.exports